import {ChangeRequestComment} from 'src/openapi/models/ChangeRequestComment';

export const sortComments = (
    comments: ChangeRequestComment[],
): ChangeRequestComment[] => {
    return [...comments.toSorted((a, b) => {
        return (b?.creationDate ?? '').localeCompare(a?.creationDate ?? '');
    })];
};
